import { IComponentOptions } from 'angular';
import { CreditGapsTransferTableCtrl } from './credit-gaps-transfer-table.controller';

export const CreditGapsTransferTableComponent: IComponentOptions = {
  bindings: {},
  controller: CreditGapsTransferTableCtrl,
  template: require('./credit-gaps-transfer-table.html'),
};
